<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
</style>
<script>
  export default{
    data(){
      return {
      }
    },
    components: {}
  }
</script>
